import { createContext, useContext, useMemo, useState } from "react";

const ApiInfoValueContext = createContext();
const ApiInfoActionsContext = createContext();

export function ApiInfoContextProvider({ children }) {
    // 로컬스토리지에서 초기 값 불러오기
    const storedKeys = JSON.parse(localStorage.getItem('api-info')) || {
        apiKey: '',
        secretKey: ''
    };
    const [apiInfo, setApiInfo] = useState(storedKeys);

    const actions = useMemo(
        () => {
            return {
                onSet(newApiKey, newSecretKey) {
                    const keys = {
                        apiKey: newApiKey,
                        secretKey: newSecretKey
                    };

                    // 로컬스토리지에 저장
                    localStorage.setItem('api-info', JSON.stringify(keys));
                    setApiInfo(keys);
                },
                onClear() {
                    localStorage.removeItem('api-info');
                    setApiInfo({
                        apiKey: '',
                        secretKey: ''
                    });
                }
            }
        },
        []
    )

    return (
        <>
            <ApiInfoActionsContext.Provider value={actions}>
                <ApiInfoValueContext.Provider value={{ apiInfo }}>
                    {children}
                </ApiInfoValueContext.Provider>
            </ApiInfoActionsContext.Provider>
        </>
    );
}

export function useApiInfoContextValueHook(props) {
    const value = useContext(ApiInfoValueContext);

    if (value === undefined) {
        throw new Error('useApiInfoContextValueHook should be used within ApiInfoValueContext');
    }

    return {
        apiInfo: {
            apiKey: value?.apiInfo?.apiKey,
            secretKey: value?.apiInfo?.secretKey
        },
    };
}

export function useApiInfoContextActionsHook(props) {
    const value = useContext(ApiInfoActionsContext);

    if (value === undefined) {
        throw new Error('useApiInfoContextActionsHook should be used within ApiInfoActionsContext');
    }

    return {
        onSet: value.onSet,
        onClear: value.onClear
    };
}